export default __webpack_public_path__ + "static/media/benifit-two-icon.eb6542a8.svg";